import React from 'react';

const USE_CASES = [
  {
    title: 'Owner-operators',
    bullets: [
      'Stay in touch with the friends you actually want to ride with',
      'Find someone to talk to on a long, empty stretch of highway',
      'Skip the CB hum — only hear the channels you opted into',
    ],
  },
  {
    title: 'Fleets & dispatchers',
    bullets: [
      'Dispatcher-to-driver groups that survive shift changes',
      'Per-route or per-customer convoy channels',
      'Faster, lower-friction comms than a phone tree or radio queue',
    ],
  },
  {
    title: 'Convoy & enthusiast groups',
    bullets: [
      'Run a private channel for a multi-truck haul',
      'Find the nearest driver in your group with a tap',
      'Coordinate fuel stops, accidents, and weather in real time',
    ],
  },
];

export const UseCases: React.FC = () => {
  return (
    <section id="use-cases">
      <div className="container">
        <span className="section-eyebrow">Who it's for</span>
        <h2 className="section-title">Built for everyone who lives on the road.</h2>
        <p className="section-subtitle">
          Whether you're solo, dispatching a fleet, or running a convoy with
          friends, RoadStatic gives you the channels you need without the
          static.
        </p>

        <div className="usecase-grid">
          {USE_CASES.map((u) => (
            <div className="usecase-card" key={u.title}>
              <h3>{u.title}</h3>
              <ul>
                {u.bullets.map((b) => (
                  <li key={b}>{b}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
